import { Banner, Link, Primary13SemiBold } from '@sequencehq/core-components'
import { QuoteContentBanner } from 'modules/Cube/view/layouts/quote/QuoteContentColumn/QuoteContentBanner'
import { useSupersededQuoteBanner } from './useSupersededQuoteBanner'

export const SupersededQuoteBanner = () => {
  const { isVisible, supersedingQuote } = useSupersededQuoteBanner()

  if (!isVisible) {
    return null
  }

  return (
    <QuoteContentBanner>
      <Banner variant="warning" data-testid="quote.supersededBanner">
        <Link
          {...Primary13SemiBold}
          color="inherit"
          textDecoration="underline"
          to={`/quotes/${supersedingQuote.id}`}
          data-testid="quote.supersededBanner.link"
        >
          {supersedingQuote.label}
        </Link>{' '}
        was accepted for this schedule amendment, this amendment is now invalid
      </Banner>
    </QuoteContentBanner>
  )
}
